import React, { useRef } from 'react'
import styles from './ShadowBox.module.css'

import { useInView } from 'react-intersection-observer'

export default function ShadowBox(props) {
  const {
    caterer,
    city,
    photos,
    photo = photos?.[0],
    placeholder
  } = props

  const [ref, inView] = useInView({
    rootMargin: '10px 0px 10px 0px',
    threshold: 0.1,
    triggerOnce: true
  })

  return (
    <div
      ref={ref}
      className={[
        styles.box,
      ]}
      style={{
        backgroundImage: photo && inView
          ? `url(${photo.url})`
          : placeholder ? `url(${placeholder})` : undefined
      }}
    >
      <a
        href={`/${caterer.slug}/`}
        className={styles.cover}
      >
        <h4>{caterer.name}</h4>
        {city && (
          <div className={styles.city}>
            {city.name}
          </div>
        )}
      </a>
    </div>
  )
}
